export default "__VITE_ASSET__jQm0fZh0__"